import React, { useState, useEffect } from "react";
import { Auth } from "shared/@auth/Auth";
import PropTypes from "prop-types";
import styles from "./ViewPluginDetailsModal.module.css";
import classNames from "classnames";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import TextArea from "shared/TextArea";

/**
 *
 * Interactive Modal used for viewing a plugins details. With errors shown below the details and an option to delete the plugin.
 *
 */

export function ViewPluginDetailsModal({
  title,
  errors,
  isOpen,
  onClose,
  onDelete,
  children,
}) {
  return (
    <div className={styles.padding}>
      <Modal
        isOpen={isOpen}
        title={title}
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
      >
        {children}
        <div className={styles.hr} />
        {/* <label className={styles.textAreaLabel} htmlFor="textarea">
          Errors
        </label>
        <TextArea
          onChange={(value) => {
            setCurrentErrors(value.split("\n"));
          }}
          className={styles.textArea}
          placeholder="This is where the errors would display...."
          value={currentErrors.join("\r\n")}
        /> */}
        <div className={styles["action-bar"]}>
          <ModalActionBar
            children={
              <div className={styles.buttonContainer}>
                <button
                  type="button"
                  className={classNames(styles.button, styles.deleteButton)}
                  onClick={() => {
                    onDelete();
                    onClose();
                  }}
                >
                  Delete Plugin
                </button>

                <button
                  type="button"
                  className={classNames(styles.button, styles.closeButton)}
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

ViewPluginDetailsModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Children Passed into component to be displayed above error with info about the plugin
   */
  children: PropTypes.element,
  /**
   * Function called when delete plugin is clicked
   */
  onDelete: PropTypes.func,
  /**
   * Errors at the bottom of the page
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Title at the top of the modal
   */
  title: PropTypes.string,
};
